import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Collapse, IconButton, Typography } from "@mui/material";
import { useState } from "react";
import { Link } from "react-scroll";
import type { DrawerMenuDropdownProps } from "./types/DrawerMenuDropdownProps";

export function DrawerMenuDropdown({ navItem, onClose }: DrawerMenuDropdownProps) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleSubMenu = () => setIsOpen((prev) => !prev);

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
          px: 2,
          py: 1.5,
          borderRadius: 1,
          userSelect: "none",
          fontWeight: "bold",
          textTransform: "uppercase",
        }}
        onClick={toggleSubMenu}
      >
        {navItem.title}
        <IconButton size="small" sx={{ p: 0 }}>
          {isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>

      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <Box
          sx={{
            pl: 2,
            display: "flex",
            flexDirection: "column",
            gap: 1,
          }}
        >
          {navItem.subMenu?.map((sub) => (
            <Link
              key={sub.id}
              to={sub.id}
              smooth
              offset={-100}
              duration={500}
              onClick={() => {
                onClose();
                window.history.pushState(null, "", `#${sub.id}`);
              }}
              style={{
                textDecoration: "none",
                color: "inherit",
                width: "100%",
                display: "block",
                boxSizing: "border-box",
              }}
            >
              <Typography
                sx={{
                  px: 1.5,
                  py: 1.5,
                  borderRadius: 1,
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  "&:hover": { backgroundColor: "rgba(0,0,0,0.08)" },
                }}
              >
                {sub.title}
              </Typography>
            </Link>
          ))}
        </Box>
      </Collapse>
    </Box>
  );
}
